import { spacing } from '@nubank/nuds-web/styles/themeUtils';
import styled from 'styled-components';

export const VariantItemWrapper = styled.div`
    width: 100%;
    display: block;
    justify-content: space-between;
    border-bottom: solid;
    border-bottom-width: 1px;
    border-bottom-color: #6A6A6A;
    padding-top: ${spacing('6x')};
    padding-bottom: ${spacing('6x')};

    &:last-child {
        margin-bottom: 2.5rem;
    }
`;

VariantItemWrapper.disable = 'VariantItemWrapper';
